import React, { ChangeEvent, Dispatch, FC, SetStateAction } from 'react';
import { styled } from 'linaria/react';
import { TextField } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Icon } from '@shared/ui/atoms';
import search from '@shared/assets/images/cyber/Search.svg';
import { CrossIcon } from '@shared/assets/icons';
interface SearchBankTextFieldProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}
const SearchBankTextField: FC<SearchBankTextFieldProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  const handleValueClear = () => {
    setSearchTerm('');
  };
  const handleChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.currentTarget.value);
  };
  return <SearchInputWrapper>
      <TextField value={searchTerm} onChange={handleChangeValue} placeholder="Поиск по сайту" controlChildren={<Icon isCustomIcon icon={search} />} />
      {searchTerm && <IconWrapper onClick={handleValueClear}>
          <CrossIcon />
        </IconWrapper>}
    </SearchInputWrapper>;
};
export default SearchBankTextField;
const IconWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconWrapper",
  class: "i1ptv7fg",
  propsAsIs: false
}));
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.secondary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const SearchInputWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "SearchInputWrapper",
  class: "s1sqrbkt",
  propsAsIs: false,
  vars: {
    "s1sqrbkt-0": [_exp2()],
    "s1sqrbkt-1": [_exp3()],
    "s1sqrbkt-2": [_exp4()]
  }
}));

require("./SearchBankTextField.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SearchBankTextField.tsx");